class Booking_panel {
    constructor() {
        this.elements = document.querySelectorAll('[data-type="quick-book"]');
        this.panel = document.querySelector('.js-main-panel');
        this.daterange = this.panel.querySelector('.js-daterange') ?? false;
        this.guest_promo = this.panel.querySelector('.js-guest-promo-popup') ?? false;
        this.promo = this.panel.querySelector('.js-promo-code') ?? false;
        this.guest = this.panel.querySelector('.js-booking-guest') ?? false;
        this.property = this.panel.querySelector('.js-booking-properties') ?? false;
        this.close_panel = this.panel.querySelector('.js-close-panel');
        this.tab_group = this.panel.querySelector('.js-tab-group');
        this.tab_content_group = this.panel.querySelector('.js-tab-content-group');
        this.tabs = this.tab_group && Array.from(this.tab_group.getElementsByTagName('a'));
        this.tabs_content = this.tab_content_group && Array.from(this.tab_content_group.getElementsByClassName('js-tab-content'));
        this.booking_btn = this.panel.querySelector('.js-booking-btn');
        this.default_booking_link = document.getElementsByName('booking_engine_link');
        this.selectedItem;
    }

    get_booking_element() {
        var _self = this;
        _self.elements.forEach(function(element) {
            _self.open_booking_panel(element);
        })
    }
    
    toggle_panel_class() {
        var _self = this;
        _self.panel.removeAttribute('style');
        _self.panel.classList.toggle('js-hidden');
        _self.panel.classList.toggle('js-visible');
    }

    open_booking_panel(element) {
        var _self = this;
        element.addEventListener('click', function(e) {
            _self.toggle_panel_class()
        })
    }

    close_booking_panel() {
        var _self = this;
        _self.close_panel.addEventListener('click', function() {
            _self.toggle_panel_class();
        })
    }

    get_tab_index() {
        var _self = this;
        _self.tabs.forEach(function(el, index) {
            el.addEventListener('click', function() {
                _self.remove_child_class(_self.tabs, 'is_active');
                _self.remove_child_class(_self.tabs_content, 'is_active');
                _self.add_class_on_tab_content(index);
                el.classList.add('is_active');
            });
        });
    }

    remove_child_class(parent_el, active_class) {
        parent_el.forEach(function(e, i) {
            if(e.classList.contains(active_class)) {
                e.classList.remove(active_class)
            }
        })
    };

    add_class_on_tab_content(i) {
        var _self = this;
        _self.tabs_content[i].classList.add('is_active');
    }

    property_item() {
        var _self = this,
            item = _self.property.querySelectorAll('.js-property-item');
        
        item.forEach(ele => {
            _self.handle_property_item_click(ele);
        });
    }

    handle_property_item_click(ele) {
        var _self = this,
            selectedItem = ele.querySelector('.js-handle-dropdown');

        selectedItem.addEventListener('click', function() {    
            _self.selectedItem = '';  
            _self.selectedItem = this.querySelector('.js-selected-item'); 
            var new_element = ele.querySelector('.js-property-list');
            _self.handle_property_list_click(new_element)
            if(this.nextElementSibling.classList.contains('is_active')) {
                new_element.classList.remove('is_active');
                this.classList.remove('is_active');
            } else {
                _self.remove_child_class(_self.property.querySelectorAll('.js-property-list'), 'is_active');
                _self.remove_child_class(_self.property.querySelectorAll('.js-handle-dropdown'), 'is_active');
                new_element.classList.add('is_active');
                this.classList.add('is_active');
            }
        })
    }

    handle_property_list_click(ele) {
        var _self = this;

        ele.querySelectorAll('li').forEach(element => {
            element.addEventListener('click', function() {
                ele.classList.remove('is_active');
                _self.remove_child_class(_self.property.querySelectorAll('.js-handle-dropdown'), 'is_active');
                _self.selectedItem.innerText = this.innerText.trim();
                if(this.dataset.hasOwnProperty("keywords")) {
                    _self.selectedItem.dataset.keywords = this.dataset.keywords
                }
                _self.selectedItem.dataset.bookingLink = this.dataset.bookingLink;
                if(ele.classList.contains('js-location')) {
                    _self.handle_location_list_item_click(this.dataset.terms);
                }
            })
        });
    }

    get_default_property() {
        var _self = this,
            selectedLocation = _self.property.querySelector('.js-selected-location');
        _self.handle_location_list_item_click(selectedLocation.dataset.terms);
    }

    handle_location_list_item_click(terms) {
        var _self = this,
            propertyItems = _self.property.querySelector('.js-property').querySelectorAll('li');

        propertyItems.forEach(ele => {
            var elementTerms = ele.dataset.terms;
            if(elementTerms !== undefined) {
                elementTerms = elementTerms.split(', ');
                if(elementTerms.includes(terms)) {
                    ele.classList.add('show')
                    ele.classList.remove('hide')
                } else {
                    ele.classList.remove('show')
                    ele.classList.add('hide')
                }
            }
        });
    }

    close_property_dropdown() {
        var _self = this

        document.addEventListener('click', ({target}) => {
            if(!target.classList.contains('voyager-booking__label') 
                && !target.classList.contains('voyager-booking__selected-item')
                && !target.classList.contains('voyager-booking__properties-list-item')) {
                _self.remove_child_class(_self.property.querySelectorAll('.js-property-list'), 'is_active');
                _self.remove_child_class(_self.property.querySelectorAll('.js-handle-dropdown'), 'is_active');
            }
        })
    }

    property_init() {
        var _self = this;

        if(_self.property) {
            _self.property_item();
            _self.close_property_dropdown();
            _self.get_default_property();
        }
    }

    handle_guest_promo_popup() {
        var _self = this;
        var selectedGuest = _self.panel.querySelector('.js-guest-selected');
        selectedGuest.addEventListener('click', function() {
            this.classList.toggle('is_active');
            _self.guest_promo.classList.toggle('is_active');
        });
        _self.close_guest_dropdown();
    }  
    
    close_guest_dropdown() {
        var _self = this;
        document.addEventListener('click', ({target}) => {
            const isInsideWrapper = target.closest(".js-guest-promo-popup");
            if(!target.classList.contains('voyager-booking__guest-wrap') 
                && !target.classList.contains('voyager-booking__guest_selected')
                && !target.classList.contains('voyager-booking__label') 
                && !isInsideWrapper 
            ) {
                _self.guest_promo.classList.remove('is_active')
            }
        })
    }    

	guest_number_change(divWrap) {
		var _self = this;
		var input = divWrap.querySelector('[type="number"]');
		var increaseValue = divWrap.querySelector(".js-increase-value");
		var decreasValue = divWrap.querySelector(".js-decreas-value");
		_self.increase_guest_value(input, increaseValue);
		_self.decreas_guest_value(input, decreasValue);
	}

	increase_guest_value(input, increaseValue) {
		increaseValue.addEventListener("click", function () {
			var value = parseInt(input.value, 10);
			value = isNaN(value) ? 0 : value;
			value > 3 ? (value = 3) : "";
			value++;
			input.value = value;
		});
	}

	decreas_guest_value(input, decreasValue) {
		decreasValue.addEventListener("click", function () {
			var value = parseInt(input.value, 10);
			value = isNaN(value) ? 0 : value;

			if (input.dataset.field == "totalAdults") {
				value < 2 ? (value = 2) : "";
			} else {
				value < 1 ? (value = 1) : "";
			}

			value--;
			input.value = value;
		});
	}

    guest_promo_init() {
        var _self = this;
        if(_self.guest_promo) {
            _self.handle_guest_promo_popup();
            if(_self.guest) {
                _self.guest_number_change(_self.guest.querySelector('.js-adults-input'));
                _self.guest_number_change(_self.guest.querySelector('.js-children-input'));
            }
        }
    }

    get_booking_url() {
        var _self = this

        if(_self.default_booking_link[0].value && typeof _self.booking_btn != 'undefined' && _self.booking_btn != null) {
            _self.booking_btn.addEventListener('click', function() {
                var query = _self.default_booking_link[0].value;
                if(_self.property) {
                    var propertyLink = _self.getPropertyQuery();
                    if(propertyLink !== undefined) {
                        query = propertyLink;
                    } else {
                        query += '/index.php?fw_submitted=1';
                    }
                } else {
                    query += '/index.php?fw_submitted=1';
                }
                
                if(_self.promo) {
                    query += _self.getPromoQuery();
                } else {
                    query += '&av=search';
                }
                
                if(_self.daterange) {
                    query += _self.getDateQuery();
                }

                if(_self.guest) {
                    query += _self.getGuestQuery();
                }

                var redirectURL = query;
                // console.log(redirectURL);
                window.location = redirectURL;                
            })

        }
        
    }

    getDateQuery() {        
        var _self = this,
            booking_checkIN = _self.panel.querySelector('[name="booking_checkIN"]').value,
            booking_checkOut = _self.panel.querySelector('[name="booking_checkOut"]').value,
            modifyCheckIN = _self.panel.querySelector('[name="checkin"]').value,
            modifyCheckOut = _self.panel.querySelector('[name="ckeckout"]').value;

        if (modifyCheckIN) {
            booking_checkIN = modifyCheckIN;
        }

        if (modifyCheckOut) {
            booking_checkOut = modifyCheckOut;
        }

        var date1 = new Date(booking_checkIN);
        var date2 = new Date(booking_checkOut);
        var Difference_In_Time = date2.getTime() - date1.getTime();
        var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return '&checkin='+ booking_checkIN +'&nights='+ Difference_In_Days;
    }

    getPromoQuery() {
        var _self = this,
            promoValue = _self.promo.querySelector('[name="promo"]').value;
        if(promoValue) {
            return '&av=promo&searchPromoCode='+ promoValue;
        } else {
            return '&av=search';
        }
    }

    getGuestQuery() {
        var _self = this,
            adults = _self.guest.querySelector('[name="adults"]').value,
            children = _self.guest.querySelector('[name="children"]').value;

        var partya = "partya="+ adults;
        if (children != 0) {
          for (let i = 0; i < children; i++) {
            partya += "%2C10";
          }
        }
        
        return '&'+ partya;
    }

    getPropertyQuery() {
        var _self = this,
            selectedLocation = _self.property.querySelector('.js-selected-location'),
            selectedProperty = _self.property.querySelector('.js-selected-property');

        if(selectedProperty.dataset.bookingLink) {
            return selectedProperty.dataset.bookingLink +'?';
        } else if (selectedLocation.dataset.bookingLink) {
            var keywords = '';
            if(selectedLocation.dataset.keywords) {
                var amp = ''
                selectedLocation.dataset.keywords.split(',').forEach((element, i) => {
                    if(i !== 0) {
                        amp = '&';
                    }
                    keywords += amp +'keywords[]='+ element.trim();                    
                });
            }
            
            return selectedLocation.dataset.bookingLink +'?'+ keywords;
        } else {
            return;
        }
    }

    variation_1_init() {
        this.get_booking_url();
        this.property_init();
        this.guest_promo_init();

        var openPanelinMobile = document.querySelector('.js-open-quick-book') 
        var ClosePanelinMobile = document.querySelector('.js-close-quick-book') 
        this.open_booking_panel(openPanelinMobile)
        this.open_booking_panel(ClosePanelinMobile)
    }

    variation_2_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.property_init();
        this.guest_promo_init();
        this.get_booking_url();
    }

    variation_3_init() {
        this.get_booking_element();
        this.close_booking_panel();
        this.get_tab_index();
        this.property_init();
        this.guest_promo_init();
        this.get_booking_url();
    }
}

const panel = document.querySelector('.js-main-panel');
const variation = panel.dataset.variation;
if( typeof(panel) != 'undefined' && panel != null ) {
    const booking_panel = new Booking_panel();
    if(variation == 'option_1') {
        booking_panel.variation_1_init();        
    }

    if(variation == 'option_2') {
        booking_panel.variation_2_init();
    }

    if(variation == 'option_3') {
        booking_panel.variation_3_init();
    }
}